import * as store from '@/store';
import * as storageUtils from '@/utils/storageUtils';
import {SidebarWidthName, RepositoryScope} from '@/Constant';
// 关闭侧边栏, 不计入缓存
export function closeSidebarWithNoStorage() {
    const sidebarOption = store.getSidebarDragOption();
    store.setSidebarDragOption({
        ...sidebarOption,
        sidebarOpen: false,
    });
}

// 从缓存同步侧边栏状态
export function syncSidebarStatusFromStorage() {
    const sidebarOption = store.getSidebarDragOption();
    let storageSidebarWidth = storageUtils.get(SidebarWidthName);
    if (!storageSidebarWidth || storageSidebarWidth.open === undefined) {
        storageSidebarWidth = {width: 240, open: true};
    }
    store.setSidebarDragOption({
        ...sidebarOption,
        sidebarWidth: storageSidebarWidth.width,
        sidebarOpen: storageSidebarWidth.open !== undefined ? storageSidebarWidth.open : true,
    });
}

// 是否展示标签聚合页
// 标签聚合页常驻
// export function isShowHomeTag() {
//     // 私密知识库 且 没有成员权限
//     const curRepository = store.getCurRepository();
//     const isPrivate = !curRepository?.scope || RepositoryScope.Repository === curRepository?.scope;
//     const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY)?.roleName;
//     return !(isPrivate && !curUserRole);
// }
